import React, { Component } from 'react';
import './Cards.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TabDataDistributor from '../../Containers/TabDataDistributor';
import { bindActionCreators } from 'redux';
import { updateCurrentTabStatus } from '../../Redux/Actions/uiActions';

import CARDSBLACKICON from '../../../assets/icons/sideNavIcons/ic_cardsBlack.png';
class Cards extends Component {

    componentDidMount() {
        this.selectedTab = this.props.location.pathname.split('/')[2];
        let tempArray = this.props.tabListArray.filter(elem => {
            return elem.toLowerCase().replace(/ /g, '').replace(/\//g, '') === this.selectedTab;
        });
        if (tempArray.length) {
            this.props.updateCurrentTabStatus(this.selectedTab);
        } else if (this.selectedTab === 'settings') {
            this.props.updateCurrentTabStatus(this.selectedTab);
        } else {
            alert('This is not a valid tab');
        }
    }

    render() {
        return (
            <>
                <div className='tab-title-wrapper'>
                    <div className='tab-title-icon-wrapper'>
                        <img src={CARDSBLACKICON} name='Cards' width='24px' height='24px' alt='Cards' />
                    </div>
                    <span className='tab-title-text' title='Cards'>Cards</span>
                </div>
                <div className='tab-pane fade active in show'>
                    <TabDataDistributor
                        tempdata={this.props.editableBotData.UI_OPTIONS ? { data: this.props.editableBotData.UI_OPTIONS.CARDS, title: 'CARDS', parentArray: ['CARDS'], isGeneric: false } : {}}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentTabStatus
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Cards));